import styled from 'styled-components';
import { Heading1Styles, Body1Styles } from '../typography';
import { getColorShade } from '../../../src/styled/utils';
export const StyledHeading = styled.h4 `
  ${Heading1Styles}
  color: ${getColorShade('onSurface', 'highEmphasis')};
  font-weight: 600;
  white-space: nowrap;
  text-align: center;
`;
export const StyledBody = styled.p `
  ${Body1Styles}
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
  white-space: nowrap;
  text-align: center;
`;
export const StyledBodyCount = styled.p `
  ${Body1Styles}
  color: ${getColorShade('onSurface', 'highEmphasis')};
  text-align: center;
`;
export const LabelWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
